import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CoachTip } from '@paypalcorp/pp-react';
import styles from './OrderActions.module.less';

const OrderActionButton = ({ content, id, onClick, data }) => {
  const { label, coachTipText } = content;
  const [isCoachOpen, setIsCoachOpen] = useState(false);

  const handleClick = () => {
    if (!data || !data.length) {
      setIsCoachOpen(true);
    } else {
      setIsCoachOpen(false);
      onClick();
    }
  };

  return (
    <>
      <Button className={styles.order_action_button} id={id} onClick={handleClick} secondary>
        {label}
      </Button>
      {isCoachOpen && (
        <CoachTip
          caretPos="top-center"
          targetElementId={id}
          text={coachTipText}
          isOpen
          onClose={() => setIsCoachOpen(false)}
        />
      )}
    </>
  );
};

OrderActionButton.propTypes = {
  content: PropTypes.object,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  coachTipText: PropTypes.string,
  data: PropTypes.any
};

OrderActionButton.defaultProps = {
  content: { label: '', coachTipText: '' },
  onClick: null,
  coachTipText: '',
  data: null
};

export default OrderActionButton;
